import { render, staticRenderFns } from "./BuyCourseBundle.vue?vue&type=template&id=6a917fe8&scoped=true&"
import script from "./BuyCourseBundle.vue?vue&type=script&lang=js&"
export * from "./BuyCourseBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a917fe8",
  null
  
)

export default component.exports